import Auth from "./components/Auth/Auth";
import { BrowserRouter, Routes, Route} from "react-router";
import NotFound from "./components/NotFound/NotFound";
import Dashboard from "./components/Dashboard/Dashboard";
import ResetPassword from "./components/ResetPassword/ResetPassword";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Dashboard/>}/>
        <Route path="/auth" element={<Auth/>}/>
        <Route path="/reset_password" element={<ResetPassword/>}/>

        <Route path="*" element={<NotFound/>}/>

      </Routes>
    </BrowserRouter>
  );
}

export default App;
